export default function SharedOrNormalWorker_fn() {
  return new SharedOrNormalWorker(__webpack_public_path__ + "static/js/entry.worker.d1f0627d.worker.js", {"credentials":"include"});
}
